import React from "react";

function AddCircleOutlinedIcon() {
  return (
    <svg width="17" height="17" viewBox="0 0 17 17" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="8.32812" cy="8.5" r="8" fill="white" />
      <path
        d="M0.328125 8.5C0.328125 7.44943 0.535051 6.40914 0.937089 5.43853C1.33913 4.46793 1.9284 3.58601 2.67127 2.84315C3.41414 2.10028 4.29605 1.511 5.26666 1.10896C6.23726 0.706926 7.27755 0.5 8.32812 0.5C9.3787 0.5 10.419 0.706926 11.3896 1.10896C12.3602 1.511 13.2421 2.10028 13.985 2.84315C14.7278 3.58601 15.3171 4.46793 15.7192 5.43853C16.1212 6.40914 16.3281 7.44943 16.3281 8.5C16.3281 10.6217 15.4853 12.6566 13.985 14.1569C12.4847 15.6571 10.4499 16.5 8.32812 16.5C6.20639 16.5 4.17156 15.6571 2.67127 14.1569C1.17098 12.6566 0.328125 10.6217 0.328125 8.5ZM8.32812 4.5C8.15131 4.5 7.98175 4.57024 7.85672 4.69526C7.7317 4.82029 7.66146 4.98986 7.66146 5.16667V7.83333H4.99479C4.81798 7.83333 4.64841 7.90357 4.52339 8.0286C4.39836 8.15362 4.32812 8.32319 4.32812 8.5C4.32812 8.67681 4.39836 8.84638 4.52339 8.97141C4.64841 9.09643 4.81798 9.16667 4.99479 9.16667H7.66146V11.8333C7.66146 12.0101 7.7317 12.1797 7.85672 12.3047C7.98175 12.4298 8.15131 12.5 8.32812 12.5C8.50494 12.5 8.67451 12.4298 8.79953 12.3047C8.92455 12.1797 8.99479 12.0101 8.99479 11.8333V9.16667H11.6615C11.8383 9.16667 12.0078 9.09643 12.1329 8.97141C12.2579 8.84638 12.3281 8.67681 12.3281 8.5C12.3281 8.32319 12.2579 8.15362 12.1329 8.0286C12.0078 7.90357 11.8383 7.83333 11.6615 7.83333H8.99479V5.16667C8.99479 4.98986 8.92455 4.82029 8.79953 4.69526C8.67451 4.57024 8.50494 4.5 8.32812 4.5Z"
        fill="url(#paint0_linear_4407_81351)"
      />
      <defs>
        <linearGradient
          id="paint0_linear_4407_81351"
          x1="8.32812"
          y1="0.5"
          x2="8.32813"
          y2="16.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#9EF01A" />
          <stop offset="1" stopColor="#007200" />
        </linearGradient>
      </defs>
    </svg>
  );
}
export default React.memo(AddCircleOutlinedIcon);
